import * as yup from 'yup';
import { FORM_KEYS } from 'shared/constant';
import isCorrectCivilID from './civilId.validation';

const { ID_PASSPORT } = FORM_KEYS;

export const idPassportSchema = (intl, elementName, isWithCivilId) => {
  switch (elementName) {
    case ID_PASSPORT.FULL_NAME:
      return yup.object().shape({
        [ID_PASSPORT.FULL_NAME]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'step.idPassport.fullName' }) }))
          .max(25, intl.formatMessage({ id: 'validation.invalidMaxNumberOfChars' })),
      });
    case ID_PASSPORT.CIVIL_ID:
      return yup.object().shape({
        [ID_PASSPORT.CIVIL_ID]: yup
          .string()
          // .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'step.idPassport.civilId' }) }))
          // .min(8, intl.formatMessage({ id: 'validation.invalidMinNumberOfChars' }))
          .test(
            intl.formatMessage({ id: 'validation.invalidCivilId' }),
            intl.formatMessage({ id: 'validation.invalidCivilId' }),
            (value) => {
              if (isWithCivilId === 'yes' && value) {
                if (isCorrectCivilID(value)) return true;
              } else if (isWithCivilId === 'no') {
                return true;
              }

              return false;
            },
          ),
      });
    case ID_PASSPORT.PASSPORT_ID:
      return yup.object().shape({
        [ID_PASSPORT.PASSPORT_ID]: yup
          .string()
          // .min(5, intl.formatMessage({ id: 'validation.invalidMinNumberOfChars' }))
          .test(
            intl.formatMessage({ id: 'validation.passportId' }),
            intl.formatMessage({ id: 'validation.passportId' }),
            (value) => {
              if (isWithCivilId === 'no' && value && value.length >= 6) {
                return true;
              } if (isWithCivilId === 'yes') {
                return true;
              }
              return false;
            },
          ),
        // .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'step.idPassport.passportId' }) })),
      });
    case ID_PASSPORT.SELFIE:
      return yup.object().shape({
        [ID_PASSPORT.SELFIE]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case ID_PASSPORT.CIVIL_ID_FRONT:
      return yup.object().shape({
        [ID_PASSPORT.CIVIL_ID_FRONT]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case ID_PASSPORT.CIVIL_ID_BACK:
      return yup.object().shape({
        [ID_PASSPORT.CIVIL_ID_BACK]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case ID_PASSPORT.PASSPORT:
      return yup.object().shape({
        [ID_PASSPORT.PASSPORT]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    default:
      return null;
  }
};

export const idPassportPageSchema = (intl, isWithCivilId) => yup.object().shape({
  [ID_PASSPORT.FULL_NAME]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'step.idPassport.fullName' }) })),
  [ID_PASSPORT.CIVIL_ID]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.invalidCivilId' }),
      intl.formatMessage({ id: 'validation.invalidCivilId' }),
      (value) => {
        if (isWithCivilId === 'yes' && value) {
          if (isCorrectCivilID(value)) {
            // console.log('yes with civil id', value);
            return true;
          }
          return false;
        }

        if (isWithCivilId === 'no') {
          return true;
        }

        return false;
      },
    ),
  // .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'step.idPassport.civilId' }) })),
  [ID_PASSPORT.PASSPORT_ID]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.passportId' }),
      intl.formatMessage({ id: 'validation.passportId' }),
      (value) => {
        if (isWithCivilId === 'no' && (!value || value === null)) {
          return false;
        }
        // console.log('PASSPORT id', value);
        return true;
      },
    ),
  // .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'step.idPassport.passportId' }) })),
  [ID_PASSPORT.SELFIE]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [ID_PASSPORT.CIVIL_ID_FRONT]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [ID_PASSPORT.CIVIL_ID_BACK]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [ID_PASSPORT.PASSPORT]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
});

// export const scanningPageSchema = intl => yup.object().shape({
//   [ID_PASSPORT.SELFIE]: yup
//     .string()
//     .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
//   [ID_PASSPORT.CIVIL_ID_FRONT]: yup
//     .string()
//     .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
//   [ID_PASSPORT.CIVIL_ID_BACK]: yup
//     .string()
//     .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
//   [ID_PASSPORT.PASSPORT]: yup
//     .string()
//     .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
// });

export const scanningPageSchema = (intl, tobeEmailed) => yup.object().shape({
  [ID_PASSPORT.SELFIE]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!(value && tobeEmailed)) return false;
        return true;
      },
    ),
  [ID_PASSPORT.CIVIL_ID_FRONT]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!(value && tobeEmailed)) return false;
        return true;
      },
    ),
  [ID_PASSPORT.CIVIL_ID_BACK]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!(value && tobeEmailed)) return false;
        return true;
      },
    ),
  [ID_PASSPORT.PASSPORT]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!(value && tobeEmailed)) return false;
        return true;
      },
    ),
  // [ID_PASSPORT.TO_BE_EMAILED]: yup
  //   .string()
  //   .test(
  //     intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
  //     intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
  //     (value) => {
  //       if (!(value && tobeEmailed)) return false;
  //       return true;
  //     },
  //   ),
});

// export default idPassportSchema;
